import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useChapters(data = {}) {
  const { enabled = false, classID, configs = {}, courseID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getChapters() {
    return privateFetch
      .get(`/v1/admin/class/${classID}/course/${courseID}/chapter`, configs)
      .then((res) => res.data);
  }

  return useQuery(['chapters', { data }], getChapters, { enabled, keepPreviousData: false });
}

export default useChapters;
